module.exports = __webpack_public_path__ + "img/build.41109516.png";